module.exports = __webpack_public_path__ + "static/media/president-word-bg.7b61a753.jpg";